import type { Nullable } from 'types';

// Sentinel value for "explicitly viewing the personal account" while impersonating, distinct from
// `null` which means "no explicit choice yet - let the backend default to the customer's persisted org".
export const IMPERSONATION_PERSONAL_ORGANIZATION_ID = 'personal';

export type OrganizationState = {
  selectedOrganizationId: Nullable<string>;
  impersonationViewOrganizationId: Nullable<string>;
};

export enum OrganizationRole {
  Owner = 'owner',
  User = 'user',
}

export enum OrganizationMemberStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
}

export enum OrganizationPermission {
  PROXY_VIEW = 'PROXY_VIEW',
  PROXY_MANAGE = 'PROXY_MANAGE',
  PROXY_PURCHASE = 'PROXY_PURCHASE',
  WALLET_VIEW = 'WALLET_VIEW',
  WALLET_TOPUP = 'WALLET_TOPUP',
  CARD_VIEW = 'CARD_VIEW',
  CARD_MANAGE = 'CARD_MANAGE',
  API_KEY_MANAGE = 'API_KEY_MANAGE',
  WEBHOOK_MANAGE = 'WEBHOOK_MANAGE',
  MEMBERSHIP_MANAGE = 'MEMBERSHIP_MANAGE',
  ORGANISATION_MANAGE = 'ORGANISATION_MANAGE',
  VPN_VIEW = 'VPN_VIEW',
  VPN_MANAGE = 'VPN_MANAGE',
  ORDER_VIEW = 'ORDER_VIEW',
  ORDER_PURCHASE = 'ORDER_PURCHASE',
}
